import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { S3 } from 'aws-sdk';
import { saveAs } from 'file-saver';
import { DATETIME_FORMAT_FILE_PREFIX_S3 } from '../../utils/constant';
import * as moment from 'moment';
import * as _ from 'lodash';
import { HelperService } from '../helper/helper.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class S3Service {

  constructor(
    private authService: AuthService,
    private helper: HelperService
  ) { }

  public download({ bucketName, key, filename }: {bucketName: string, key: string, filename?: string}, callback: (err?, data?: any) => void){
    this.authService.checkAWSCredentials( (err) => {
      if(err){
        return callback(err);
      }

      let bucket = new S3();

      let params = {
        Bucket: bucketName,
        Key: key,
      };

      bucket.getObject(params, (err, data) => {
        if(err){
          return callback(err);
        }
        saveAs(new Blob([data.Body as any], { type: data.ContentType }), filename);
        callback(null, data);
      });
    });
  }

  public upload(
    { bucketName, file, options }: { bucketName: string, file: File, options?: S3.ManagedUpload.ManagedUploadOptions },
    callback: (err?, s3Key?: any) => void
  ) {
    this.authService.checkAWSCredentials((err) => {
      if (err) {
        return callback(err);
      }

      let bucket = new S3({ region: environment.region });
      let key = this.generateKeyForUpload(file.name);

      let params = {
        Bucket: bucketName,
        Key: key,
        Body: file,
        ContentType: file.type
      };
      // console.log("S3 uploading params: ", params);
      bucket.upload(params, options, (err) => {
        if (err) {
          return callback(err);
        }
        callback(null, key);
      });
    });
  }

  private generateKeyForUpload(raw_filename: string): string {
    let extraPrefix = this.helper.randomString(6);
    let kebabFilename = _.kebabCase(raw_filename);
    let filename = getFilename(kebabFilename);
    let fileTypeExtension = getFileTypeExtension(kebabFilename);
    let now = moment().format(DATETIME_FORMAT_FILE_PREFIX_S3);

    function getFilename(kebab_filename: string) {
      let filename_array = kebab_filename.split('-');
      filename_array.pop()
      return filename_array.join('-')
    }

    function getFileTypeExtension(kebab_filename: string) {
      let filename_array = kebab_filename.split('-');
      return filename_array[filename_array.length - 1];
    }

    let key = `${extraPrefix}-${now}-${filename}.${fileTypeExtension}`;
    return key;
  }


}
